import { render } from "./PopularBox.vue?vue&type=template&id=468d09b5&scoped=true"
import script from "./PopularBox.vue?vue&type=script&lang=js"
export * from "./PopularBox.vue?vue&type=script&lang=js"

import "./PopularBox.vue?vue&type=style&index=0&id=468d09b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468d09b5"]])

export default __exports__